// Recordar si la persona dejó abierto o cerrado algo desplegable (la tarjeta de cobranza y cada una de
// sus secciones), entre trámites y recargas. Es una comodidad: si el navegador no deja usar el
// almacenamiento (navegación privada, bloqueado) se usa el valor por defecto y todo funciona igual.

export function leerPreferenciaAbierta(clave, porDefecto) {
    try {
        const guardado = window.localStorage.getItem(clave);
        return guardado === null ? porDefecto : guardado === '1';
    } catch {
        return porDefecto;
    }
}

export function guardarPreferenciaAbierta(clave, abierta) {
    try {
        window.localStorage.setItem(clave, abierta ? '1' : '0');
    } catch {
        // Sin almacenamiento solo se pierde la preferencia.
    }
}
